import { message } from '@maxtropy/components';
import dayjs, { Dayjs } from 'dayjs';
import { ModalType, RangeValue, TimeActive } from './type';

// 边界处理
export const onChangePicker = (
  dates: RangeValue,
  activeKey: TimeActive,
  setValue: React.Dispatch<React.SetStateAction<RangeValue>>,
  onRangeDateChange?: (rangeDate: [Dayjs, Dayjs]) => void
) => {
  let isFlag = true;
  switch (activeKey) {
    case TimeActive.THIS_MONTH:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(12, 'month').valueOf() < dates?.[1].valueOf()) {
        isFlag = false;
        message.error('最多选择12个月');
      }
      break;
    case TimeActive.THIS_YEAR:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(3, 'year').valueOf() < dates?.[1].valueOf()) {
        message.error('最多选择3年');
        isFlag = false;
      }
      break;
    case TimeActive.THIS_DAY:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(31, 'day').valueOf() < dates?.[1].valueOf()) {
        message.error('最多选择31天');
        isFlag = false;
      }
      break;
    case TimeActive.THIS_WEEK:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(12, 'week').valueOf() < dates?.[1].valueOf()) {
        message.error('最多选择12周');
        isFlag = false;
      }
      break;
  }
  if (isFlag) {
    const start = dates[0].startOf('day');
    const end = dates[1].endOf('day');
    const newDates: RangeValue = [start, end];
    setValue(newDates);
    onRangeDateChange?.(newDates);
  }
};

// 默认时间范围
export const getDefaultRangeByActiveKey = (activeKey: TimeActive, switchOption?: ModalType): [Dayjs, Dayjs] => {
  const now = dayjs().endOf('day');
  switch (activeKey) {
    case TimeActive.THIS_DAY:
      if (switchOption === ModalType.FlowMeter || switchOption === ModalType.PipeLoss) {
        return [now.subtract(6, 'day').startOf('day'), now]; // 近7日
      }
      return [now.subtract(30, 'day').startOf('day'), now];
    case TimeActive.THIS_MONTH:
      return [now.subtract(11, 'month').startOf('month'), now.endOf('month')];
    case TimeActive.THIS_YEAR:
      return [now.subtract(2, 'year').startOf('year'), now.endOf('year')];
    case TimeActive.THIS_WEEK:
      return [now.subtract(11, 'week').startOf('week'), now.endOf('week')];
    default:
      return [now.subtract(30, 'day').startOf('day'), now];
  }
};

// 默认activeKey
export const getDefaultActiveKey = (urlActiveKey?: string) => {
  if (urlActiveKey && Object.values(TimeActive).includes(urlActiveKey as TimeActive)) {
    return urlActiveKey as TimeActive;
  }
  return TimeActive.THIS_DAY;
};

// 根据 activeKey 决定日期格式
export const TimePickerUtil = (activeKey: TimeActive) => {
  if (activeKey === TimeActive.THIS_MONTH) {
    return 'month';
  } else if (activeKey === TimeActive.THIS_YEAR) {
    return 'year';
  } else if (activeKey === TimeActive.THIS_DAY) {
    return 'date';
  } else if (activeKey === TimeActive.THIS_WEEK) {
    return 'week';
  } else {
    return 'month';
  }
};
